import { batch, signal } from "@preact/signals-react"

export const newsAnnouncements = signal([])
export const newsAudiences = signal({ companies: [], users: [] })
export const isLoadingNews = signal(false)
// A failed listing is not "no announcements yet"; failed audiences block saving (empty = everyone)
export const newsListFailed = signal(false)
export const newsAudiencesFailed = signal(false)

export const newsFilters = signal({ company: null, uid: null, state: 'all' })

// null = creating one; a listing row = editing that one
export const isNewsEditorOpen = signal(false)
export const editingAnnouncement = signal(null)

export const openNewsEditor = (row = null) => batch(() => {
	editingAnnouncement.value = row
	isNewsEditorOpen.value = true
})

export const closeNewsEditor = () => batch(() => {
	isNewsEditorOpen.value = false
	editingAnnouncement.value = null
})

export const clearNewsManagementSignals = () => batch(() => {
	newsAnnouncements.value = []
	newsAudiences.value = { companies: [], users: [] }
	newsListFailed.value = false
	newsAudiencesFailed.value = false
	newsFilters.value = { company: null, uid: null, state: 'all' }
	closeNewsEditor()
})
